import { useQuery } from "@tanstack/react-query";
import { getMyDay } from "@/features/attendance/attendance.api";

/**
 * The caller's own schedule for a date.
 *
 * Separate from the attendance record because it answers a different question
 * and answers it earlier: "what am I meant to be working" has to be answerable
 * before anybody has checked in, and therefore before any record exists.
 *
 * A shift assignment changes about once a quarter, so this is held for the
 * session rather than refetched with the day view.
 */
export function useMyDay(workspaceId: string | undefined, date: string) {
  return useQuery({
    queryKey: ["attendance", "my-day", workspaceId, date],
    queryFn: () => {
      if (!workspaceId) throw new Error("workspaceId required");
      return getMyDay(workspaceId, date);
    },
    enabled: Boolean(workspaceId),
    staleTime: 10 * 60_000,
  });
}
